import { ApiService } from "@/config";
import { handleError } from "@/utils/parseApiReturn";
import { IAllMetricsResponse } from "../models/interfaces/dashboard";

const buildDashboard = async (
  startDate: string,
  endDate: string
): Promise<IAllMetricsResponse> => {
  try {
    const res = await ApiService.get("/bi/build-dashboard", {
      startDate,
      endDate
    });
    return res.data;
  } catch (error: unknown) {
    const { success } = handleError(
      error,
      "Erro ao obter status de consultados"
    );
    return { success };
  }
};
export const BIService = {
  buildDashboard
};
